(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const COLLECTION_SCROLL_STORAGE_KEY = 'collection-menu-scroll-position';

  const tryRestoreCollectionScrollPosition = (storedData) => {
    if (!storedData || storedData.path !== window.location.pathname) {
      return true;
    }

    window.scrollTo(0, storedData.position);

    return Math.abs(window.scrollY - storedData.position) <= 1;
  };

  const storedScrollPosition = (() => {
    const storedValue = sessionStorage.getItem(COLLECTION_SCROLL_STORAGE_KEY);

    if (!storedValue) {
      return null;
    }

    try {
      return JSON.parse(storedValue);
    } catch (error) {
      console.warn('Unable to parse stored collection scroll position', error);
      sessionStorage.removeItem(COLLECTION_SCROLL_STORAGE_KEY);
      return null;
    }
  })();

  if (storedScrollPosition) {
    const clearStoredScrollPosition = () => {
      sessionStorage.removeItem(COLLECTION_SCROLL_STORAGE_KEY);
    };

    if (!tryRestoreCollectionScrollPosition(storedScrollPosition)) {
      window.addEventListener(
        'load',
        () => {
          requestAnimationFrame(() => {
            tryRestoreCollectionScrollPosition(storedScrollPosition);
            clearStoredScrollPosition();
          });
        },
        { once: true }
      );
    } else {
      clearStoredScrollPosition();
    }
  }

  const persistCollectionScrollPosition = (event) => {
    const link = event.currentTarget;

    try {
      const destination = new URL(link.href, window.location.origin);
      sessionStorage.setItem(
        COLLECTION_SCROLL_STORAGE_KEY,
        JSON.stringify({ path: destination.pathname, position: window.scrollY })
      );
    } catch (error) {
      console.warn('Unable to persist collection scroll position', error);
    }
  };

  const initializeCollectionMenuScrollPersistence = () => {
    const collectionMenuLinks = document.querySelectorAll('[data-collection-menu-link]');

    if (!collectionMenuLinks.length) {
      return;
    }

    collectionMenuLinks.forEach((link) => {
      link.addEventListener('click', persistCollectionScrollPosition, { capture: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCollectionMenuScrollPersistence, { once: true });
  } else {
    initializeCollectionMenuScrollPersistence();
  }

  } catch(e) { console.error(e); }
})();
})();
